import styled from 'styled-components';
import { mediaq } from '~/themes/style-utils-v2';
import { newColors } from '~/themes/variables';
export const Outer = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;
export const Inner = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
// padding-right: 84px;
// padding-left: 84px;
// ${mediaq.md`
// padding-right: 48px;
// padding-left: 48px;
// `}
// ${mediaq.sm`
// padding-right: 12px;
// padding-left: 12px;
// `}
export const Label = styled.label `
  font-size: 12px;
  font-weight: 600;
  text-align: left;
  padding-left: 4px;
  max-width: 140px;
`;
export const SelectField = styled.select `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 51px;
  text-align: left;
  background: ${newColors.snow};
  border-radius: 12px;
  border: ${(props) => props.isError ? `1px ${newColors.error} solid` : `1px ${newColors.purple800} solid`};
  padding-left: 6px;
  padding-right: 6px;
  color: ${newColors.fontDefaultColor};
  outline: none;
  ${mediaq.sm `
  border-radius: 6px;
  height: 40px;`}
`;
export const Message = styled.div `
  width: 100%;
  font-size: 12px;
  color: ${newColors.error};
  text-align: left;
`;
// padding-left: 88px;
// ${mediaq.md`
// padding-left: 52px;
// `}
// ${mediaq.sm`
// padding-left: 16px;
// `}
export const Asterisk = styled.span `
  color: ${newColors.error};
  margin-left: 2px;
`;
